import { watch } from 'vue';
import { usePrivacyConsent } from '~/composables/usePrivacyConsent';
import { CONSENT_MAX_AGE } from '~/utils/privacy-consent';
import { createConsentTracker } from '~/utils/consent-tracker';
export default defineNuxtPlugin((nuxtApp) => {
  const consent = usePrivacyConsent();
  const tracker = createConsentTracker(window, document, {
    gtmId: useRuntimeConfig().public.gtmId
  });
  const refresh = () => consent.syncFromCookie();
  let expiryTimer;
  function scheduleExpiry() {
    clearTimeout(expiryTimer);
    const record = consent.record.value;
    if (!record) return;
    const remaining = record.updatedAt + CONSENT_MAX_AGE * 1000 - Date.now();
    expiryTimer = setTimeout(
      () => {
        refresh();
        scheduleExpiry();
      },
      Math.max(1, Math.min(remaining, 2147483647))
    );
  }
  const storage = (event) => {
    if (event.key === 'idmanify:consent-sync') refresh();
  };
  nuxtApp.hook('app:mounted', () => {
    refresh();
    watch(
      consent.record,
      (record) => {
        tracker.update(record);
        scheduleExpiry();
        tracker.page(nuxtApp.$router.currentRoute.value.fullPath);
      },
      { immediate: true, flush: 'sync' }
    );
    nuxtApp.$router.afterEach((to) => tracker.page(to.fullPath));
    window.addEventListener('storage', storage);
    window.addEventListener('focus', refresh);
  });
});
